/**
 * 
 */

import 'shared/blueprint'
import 'shared/blueprint-theme'
import 'shared/blueprint-icons-font'
import 'shared/galaTypography'

import { FocusStyleManager } from '@blueprintjs/core'
FocusStyleManager.onlyShowFocusOnTabs()
